import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetComponentes(unidadeIdExterno?: string, ocupacaoId?: string) {
  return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER_COMPONENTE_DROPDOWN_ID_EXTERNO, unidadeIdExterno, ocupacaoId],
    async () => {
      const { data } = await http.get(URL.PLANO_OPERACIONAL.OBTER_COMPONENTE_DROPDOWN_ID_EXTERNO, {
        params: { unidadeIdExterno, ocupacaoId },
      });
      return data;
    },
    {
      enabled: !!unidadeIdExterno,
    },
  );
}

export default useGetComponentes;
